import React, { useEffect } from "react";
import {
    Box,
    Button,
    FormControl,
    TextField,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    InputAdornment,
} from "@material-ui/core";

import {
    MATERIAL_UI_PROPS,
    rateChangeOperations,
    VALUE_TYPES,
    INHERIT_VALUES,
} from "../../../lib/data";
import clientConfig from "../../../config/client";

const BASE_RATE_ID = "base-rate";
const OPERATION_ID = "rate-operation";
const AMNT_ID = "amount-id";
const UNIT_ID = "unit-id";
const locale = clientConfig.locale;

const LABELS = {
    startBtn: { ru: "Начать наследование тарифа", en: "Start inheritance" },
    submitBtn: { ru: "Сохранить", en: "Submit" },
    noRates: { ru: "Нет тарифов для наследования", en: "No rates to inherit" },
    confirm: {
        ru: "Вы уверены (ранее внесенные цены в тариф будут перезаписаны)?",
        en: "Are you sure (all connected prices will be overwritten)?",
    },
    inheritedRate: {
        ru: "Базовый тариф",
        en: "Base rate",
    },
    operation: {
        ru: "Операция",
        en: "Operation",
    },
    valueType: {
        ru: "Тип значения",
        en: "Amount type",
    },
    amount: {
        ru: "Количество",
        en: "Amount",
    },
    inheritance_stops: {
        ru: "Наследовать стопы",
    },
    inheritance_discount_check: {
        ru: "Отображение скидки",
        en: "Displaying a discount",
    },
};

export const rateInheritingHandler = (
    allItems,
    inheritanceFunc,
    fieldUpdateHandler,
    value,
    inheritStarted,
    rates,
    hotelId,
) => {
    const allRates =
        allItems?.length > 0 ? allItems : rates?.length > 0 ? rates : [];

    if (allRates && allRates?.length === 0) {
        return <Typography>{LABELS.noRates[locale]}</Typography>;
    }

    const confirmStartInherit = () => {
        if (confirm(LABELS.confirm[locale])) {
            fieldUpdateHandler("inheritStarted", true);
        }
    };

    const changeRateHandler = (e) => {
        fieldUpdateHandler("base_rate_id", e.target.value);
    };

    const changeValueTypeHandler = (e) => {
        const amntType = e.target.value === "digit" ? "number" : e.target.value;
        fieldUpdateHandler("inheritance_unit", amntType);
    };

    const changeOperationHandler = (e) => {
        fieldUpdateHandler("inheritance_operation", e.target.value);
    };

    const changeAmountHandler = (e) => {
        const updatedValue = e.target.value.includes("-")
            ? "0"
            : e.target.value;
        fieldUpdateHandler("inheritance_value", updatedValue);
    };

    const handleInheritanceStopsChange = (e) => {
        fieldUpdateHandler("inheritance_stops", e.target.value);
    };

    const handleInheritanceDiscountCheckChange = (e) => {
        fieldUpdateHandler("inheritance_discount_check", e.target.value);
    };

    const submitHandler = () => {
        inheritanceFunc();
    };

    const operations = { ...rateChangeOperations };

    if (value.inheritance_unit === VALUE_TYPES.percent.value) {
        Reflect.deleteProperty(operations, rateChangeOperations.multiply.value);
        Reflect.deleteProperty(operations, rateChangeOperations.divide.value);
    }

    if (+value.inheritance_value <= 0) {
        Reflect.deleteProperty(operations, rateChangeOperations.divide.value);
    }

    const endIcon =
        value.inheritance_unit === "number"
            ? {
                  endAdornment: (
                      <InputAdornment position="end">&#8381;</InputAdornment>
                  ),
              }
            : {
                  endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                  ),
              };

    return (
        <React.Fragment>
            {inheritStarted ? (
                <Box display="flex">
                    <Box mr=".7rem">
                        <FormControl
                            variant={MATERIAL_UI_PROPS.varinats.outlined}
                            size={MATERIAL_UI_PROPS.sizes.small}
                            style={{ width: "9rem" }}
                        >
                            <InputLabel htmlFor={BASE_RATE_ID}>
                                {LABELS.inheritedRate[locale]}
                            </InputLabel>
                            <Select
                                label={LABELS.inheritedRate[locale]}
                                labelId={BASE_RATE_ID}
                                id={BASE_RATE_ID}
                                value={value.base_rate_id || ""}
                                onChange={changeRateHandler}
                                title={
                                    allRates.filter(
                                        (rate) =>
                                            rate.id === value.base_rate_id,
                                    )[0]?.name
                                }
                            >
                                {allRates.map((rate, rateIdx) => (
                                    <MenuItem
                                        key={`rateIdx${rateIdx}`}
                                        value={rate.id}
                                    >
                                        {rate.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box mr=".7rem">
                        <FormControl
                            variant={MATERIAL_UI_PROPS.varinats.outlined}
                            size={MATERIAL_UI_PROPS.sizes.small}
                            style={{ width: "9rem" }}
                        >
                            <InputLabel htmlFor={OPERATION_ID}>
                                {LABELS.operation[locale]}
                            </InputLabel>
                            <Select
                                label={LABELS.operation[locale]}
                                labelId={OPERATION_ID}
                                id={OPERATION_ID}
                                value={
                                    operations[value.inheritance_operation]
                                        ?.value
                                }
                                onChange={changeOperationHandler}
                            >
                                {Object.keys(operations).map(
                                    (oper, operIdx) => (
                                        <MenuItem
                                            key={`operIdx${operIdx}`}
                                            value={operations[oper].value}
                                        >
                                            {operations[oper].label[locale]}
                                        </MenuItem>
                                    ),
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box mr=".7rem">
                        <FormControl
                            variant={MATERIAL_UI_PROPS.varinats.outlined}
                            size={MATERIAL_UI_PROPS.sizes.small}
                            style={{ width: "7rem" }}
                        >
                            <InputLabel htmlFor={UNIT_ID}>
                                {LABELS.valueType[locale]}
                            </InputLabel>
                            <Select
                                label={LABELS.valueType[locale]}
                                labelId={UNIT_ID}
                                id={UNIT_ID}
                                value={
                                    VALUE_TYPES[
                                        value.inheritance_unit === "number"
                                            ? "digit"
                                            : value.inheritance_unit
                                    ]?.value
                                }
                                onChange={changeValueTypeHandler}
                            >
                                {Object.keys(VALUE_TYPES).map(
                                    (type, typeIdx) => (
                                        <MenuItem
                                            key={`typeIdx${typeIdx}`}
                                            value={VALUE_TYPES[type].value}
                                        >
                                            {VALUE_TYPES[type].label[locale]}
                                        </MenuItem>
                                    ),
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box mr=".7rem">
                        <TextField
                            style={{ width: "9rem" }}
                            label={LABELS.amount[locale]}
                            id={AMNT_ID}
                            variant={MATERIAL_UI_PROPS.varinats.outlined}
                            size={MATERIAL_UI_PROPS.sizes.small}
                            type="number"
                            onChange={changeAmountHandler}
                            value={value.inheritance_value || 0}
                            InputProps={endIcon}
                        />
                    </Box>
                    <Box mr=".7rem">
                        <FormControl
                            variant={MATERIAL_UI_PROPS.varinats.outlined}
                            size={MATERIAL_UI_PROPS.sizes.small}
                            style={{ width: "10rem" }}
                        >
                            <InputLabel htmlFor={"inheritance_stops"}>
                                {LABELS.inheritance_stops[locale]}
                            </InputLabel>
                            <Select
                                label={LABELS.inheritance_stops[locale]}
                                labelId={"inheritance_stops"}
                                id={"inheritance_stops"}
                                value={value?.inheritance_stops}
                                onChange={handleInheritanceStopsChange}
                            >
                                {Object.keys(INHERIT_VALUES).map(
                                    (type, typeIdx) => (
                                        <MenuItem
                                            key={`typeIdx${typeIdx}`}
                                            value={INHERIT_VALUES[type].value}
                                        >
                                            {INHERIT_VALUES[type].label[locale]}
                                        </MenuItem>
                                    ),
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box mr=".7rem">
                        <FormControl
                            variant={MATERIAL_UI_PROPS.varinats.outlined}
                            size={MATERIAL_UI_PROPS.sizes.small}
                            style={{ width: "10rem" }}
                        >
                            <InputLabel htmlFor={"inheritance_discount_check"}>
                                {LABELS.inheritance_discount_check[locale]}
                            </InputLabel>
                            <Select
                                label={
                                    LABELS.inheritance_discount_check[locale]
                                }
                                labelId={"inheritance_discount_check"}
                                id={"inheritance_discount_check"}
                                value={value?.inheritance_discount_check}
                                onChange={handleInheritanceDiscountCheckChange}
                            >
                                {Object.keys(INHERIT_VALUES).map(
                                    (type, typeIdx) => (
                                        <MenuItem
                                            key={`typeIdx${typeIdx}`}
                                            value={INHERIT_VALUES[type].value}
                                        >
                                            {INHERIT_VALUES[type].label[locale]}
                                        </MenuItem>
                                    ),
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                    <Button
                        color={MATERIAL_UI_PROPS.colors.secondary}
                        variant={MATERIAL_UI_PROPS.varinats.contained}
                        onClick={submitHandler}
                    >
                        {LABELS.submitBtn[locale]}
                    </Button>
                </Box>
            ) : (
                <Button
                    color={MATERIAL_UI_PROPS.colors.primary}
                    variant={MATERIAL_UI_PROPS.varinats.contained}
                    onClick={confirmStartInherit}
                >
                    {LABELS.startBtn[locale]}
                </Button>
            )}
        </React.Fragment>
    );
};
